import { render, staticRenderFns } from "./DraggableTask.vue?vue&type=template&id=6c633978"
import script from "./DraggableTask.vue?vue&type=script&lang=js"
export * from "./DraggableTask.vue?vue&type=script&lang=js"
import style0 from "./DraggableTask.vue?vue&type=style&index=0&id=6c633978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports